import React, { useEffect, useState } from 'react';
import Layout from '../../parts/Layout';
import { httpRequest } from '../../../services/httpService';
import helpers from '../../../services/helpers';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import Loader from '../../parts/Loader';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import DropDownSelection from '../../elements/DropDownSelection';
import Dropdown from 'react-bootstrap/Dropdown'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import initTreeView from '../../../services/initTreeView';
import store from '../../../services/store';
 
export default function BillsList ({viewer = 'admin', menu = 'manage-bills', page_title = "Manage Bills"}){
    const [record_data, setRecordData] = useState([]);
    const [loading, setLoading] = useState(1);
    const [enums, setEnums] = useState(store.order_enums);
    const [search_key, setSearchKey] = useState('');
    const [prompt_modal, setPromptModal] = useState(0);
    const [prompt_title, setPromptTitle] = useState('');
    const [prompt_caption, setPromptCaption] = useState('');
    const [prompt_error, setPromptError] = useState('');
    const [reasons_list, setResons] = useState();
    const [selected_reason, setSelectedReason] = useState('');
    const [order_id, setOrderID] = useState('');

    const [data_table, setDataTable] = useState([]);
    const [selected_items, setSelectedItems] = useState([]);
    const [selected_all, setSelectAll] = useState(false);
    const [datatable_state, setDataTableState] = useState({
        first: 0,
        rows: 10,
        page: 0,
        sortField: null,
        sortOrder: null
    });
    const [filters, setFilters] = useState({
        status: 0,
        search: ""
    });

    useEffect(() => {
        initTreeView()
        fetchDataList({
            "page": datatable_state.page + 1,
            "per_page": datatable_state.rows
        })
        getEnums()
    }, []);

    useEffect(() => {
        displayDataTable(record_data)
    }, [datatable_state.sortOrder]);

    useEffect(() => {
        displayDataTable(record_data)
    }, [
        selected_items, 
        selected_all
    ]);

    useEffect(() => {
        fetchDataList({
            "page": datatable_state.page + 1,
            "per_page": datatable_state.rows,
            //"search": search_key
        })
    }, [datatable_state, filters]);
    
    function inputChange(e) {
        let { value, name } = e.target;

        if (e.target.type === "checkbox") {
            if (e.target.checked) {
                value = 1;

                if(name == 'warranty_status') value = 'active'
            } else {
                value = 0;

                if(name == 'warranty_status') value = 'expired'
            }
        }
        else if (e.target.type === "file") {
          value = e.target.files[0]
        }

        let new_state = { [name]: value }

        setFilters({ ...filters, ...new_state });
    }

    function getEnums(){
        setLoading(1)

        const url = helpers.createUrl('V1/enums/orders?only=cancellation_reasons')
        httpRequest(url, "GET", {}, true)
        .then((res) => {
            setResons(res.cancellation_reasons)
            //setEnums(res)
            setLoading(0)
        })
        .catch((err) => {
            setLoading(0)
        }); 
    }

    function fetchDataList(condition = {
        "page": '',
        //"search": '',
        "per_page": ''
    }){
        const page = condition.page ?? datatable_state.page
        const per_page = condition.per_page ?? datatable_state.rows
        const search = condition.search ?? search_key
        let filter = `?store_id=${helpers.getStoreID()}&`

        if(page){
            filter += 'page='+page+'&'
        }
        if(per_page){
            filter += 'per_page='+per_page+'&'
        }
        if(filters.search){
            filter += 'search='+filters.search+'&'
        }
        if(filters.status){
            filter += 'status='+filters.status+'&'
        }

        filter = filter.slice(0, -1)

        setLoading(1)

        const url = helpers.createUrl('V1/manage/bills'+filter)

        httpRequest(url, "GET", {}, true)
            .then((res) => {
                setRecordData(res.list)
                setLoading(0)
                displayDataTable(res.list)
                setEnums(res.enums)
            })
            .catch((err) => {
                setLoading(0)

                Swal.fire({
                    // title: "Error!",
                    text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }); 
    }
    

    function search(e){
        let { value } = e.target;
        setSearchKey(value)
        fetchDataList({
            "page": datatable_state.page + 1,
            "search": value
        })
    }

    function triggerAction(data = '', action = '', status = ''){
        if(action === 'sent' || action === 'draft'){
            updateStatusItem(data, status)
        }
        else{
            let ids = [];
            if(action === 'single-delete'){
                ids.push(data.id)
            }
            else{
                ids = data.map(o => o['id']);
            }

            let title = 'Delete Bill'
            if(ids.length > 1){
                title = 'Delete Bills'
            }

            Swal.fire({
                title: title,
                text: 'This action cannot be reversed. All associated records will also be deleted. Do you want to continue?',
                showCancelButton: true,
                showConfirmButton: false,
                closeOnCancel: true,
                showDenyButton: true,
                denyButtonText: 'Yes'
            })
            .then((result) => {
                if (result.isDenied) {
                    deleteItem(ids)
                }
            })
        }
    }

    function updateStatusItem(id, status_id){
        const url = helpers.createUrl('V1/manage/bills/status')
        httpRequest(url, 'POST', {
            postdata: {
                "bill_id": id,
                "store_id": helpers.getStoreID(),
                "status_id": status_id
            },
        }, true)
            .then((res) => {
                setLoading(0)
                fetchDataList({
                    "page": datatable_state.page + 1,
                    "per_page": datatable_state.rows,
                    "search": search_key
                })
                setSelectedItems([])

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                })
            })
            .catch((err) => {
                console.log(err)
                setLoading(0)
                setSelectedItems([])

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 
    }

    function deleteItem(id){
        const url = helpers.createUrl('V1/manage/bills/delete')
        httpRequest(url, 'POST', {
            postdata: {
                "bill_ids": id,
                "store_id": helpers.getStoreID()
            },
        }, true)
            .then((res) => {
                setLoading(0)
                fetchDataList({
                    "page": datatable_state.page + 1,
                    "per_page": datatable_state.rows,
                    "search": search_key
                })
                setSelectedItems([])

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                })
            })
            .catch((err) => {
                setLoading(0)
                setSelectedItems([])

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 
    }

    function displayDataTable(data){
        setDataTable(
            <DataTable 
                className='border-top'
                dataKey={data.id}
                value={data.data} 
                // tableStyle={{ minWidth: '50rem' }}
                size="normal"
                paginator 
                rows={data.per_page} 
                rowsPerPageOptions={[5, 10, 20, 25, 50]}
                totalRecords={data.total}
                onPage={onPage}
                first={datatable_state.first}
                lazy
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                selection={selected_items} 
                onSelectionChange={onSelectItem}
                scrollHeight="500px"
                scrollable
                responsive={true}
                emptyMessage="No data to display"
            >
                <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                <Column field="bill_date" header="DATE" ></Column>
                <Column field="bill_no" header="BILL&nbsp;#" body={({id, bill_no})=> <Link to={`/bills/${id}`}>{bill_no}</Link>}></Column>
                <Column field="due_date" header="DUE DATE" ></Column>
                <Column field="order_no" header="ORDER&nbsp;#" body={({order_id, order_no})=> order_no ? order_no : '---'}/>
                <Column field="vendor_name" header="VENDOR" body={({vendor_id, vendor_name})=> <Link to={`/vendors/${vendor_id}/edit`}>{vendor_name}</Link>}></Column>
                <Column header="AMOUNT" body={({total_amount})=> total_amount ? helpers.formatCurrencyAmount(total_amount) : '---' }></Column>
                <Column field="balance_amount" header="BALANCE" body={({balance_amount})=> balance_amount ? helpers.formatCurrencyAmount(balance_amount) : '---' } ></Column>
                <Column field="payment_term" header="TERM" ></Column>
                {/* <Column field="payment_status" header="PAYMENT" ></Column> */}
                <Column header="STATUS" body={({status_id, bill_status})=> <h5>{helpers.displayBillStatusBadge(status_id, bill_status)}</h5>}></Column>
                <Column className="text-right" body={displayActionMenu}></Column> 
            </DataTable>
        )

    }

    function getTotal(data){
        let total_amount = data.total_amount ?? 0;
        
        if(!total_amount){
            Object.entries(data.items).map(([key, data]) => {
                const unit_price = parseFloat(data['unit_price'])
                const qty = parseInt(data['quantity'])

                total_amount += unit_price * qty;
            });
        }

        return <>&#8369;{helpers.formatAmount(total_amount)}</>
    }

    const onPage = (e) => {
        setDataTableState(e)
        setSelectedItems([])
    };

    const onSelectItem = (e) => {
        const value = e.value;
        setSelectedItems(value);
    };

    function displayActionMenu(data){
        const balance = parseFloat(data.balance_amount)

        return (<Dropdown>
                        <Dropdown.Toggle className='btn-light border' size="sm" id={"dropdown-actions-"+data.id}>Action</Dropdown.Toggle>
                        <Dropdown.Menu align="end">
                            {
                                balance > 0 ? 
                                <Dropdown.Item key="payment" as={Link}  to={`/bills/${data.id}/payment`}><i className="fas fa-credit-card mr-2" style={{width: '20px'}} />Add Payment</Dropdown.Item> : ''
                            }

                            {   
                                data.status_id === 1 ? 
                                <Dropdown.Item key="confirm" onClick={(e) => triggerAction(data.id, 'sent' , 5)}><i className="fas fa-check-circle mr-2" style={{width: '20px'}} />Set as Sent</Dropdown.Item> : ''
                            }

                            {  
                                data.status_id === 5 ? 
                                <Dropdown.Item key="confirm" onClick={(e) => triggerAction(data.id, 'draft' , 1)}><i className="far fa-file-alt mr-2" style={{width: '20px'}} />Set as Draft</Dropdown.Item> : ''
                            }
            
                            {
                                data.status_id != 5 && data.status_id != 6 && data.status_id != 7 && data.status_id != 8 ?
                                <Dropdown.Item key="edit" as={Link}  to={`/bills/${data.id}/form`}><i className="fas fa-pencil-alt mr-2" style={{width: '20px'}} />Edit</Dropdown.Item> : ''
                            }
                            
                            { (data.status_id != 3 && data.status_id != 4)  ?
                            <>
                            {/* <Dropdown.Divider /> */}
                            <Dropdown.Item key="delete" className='text-danger' onClick={(e) => triggerAction(data, 'single-delete')}><i className="fas fa-trash mr-2" style={{width: '20px'}} />Delete</Dropdown.Item>
                            </>
                             : ''}
                        </Dropdown.Menu>
                    </Dropdown>)
    }

    function closeModal(){
        setPromptModal(0)
        setOrderID('')
        setPromptTitle('')
        setPromptCaption('')
        setSelectedReason('')
        setPromptError('')
    }

    function cancelOrder(){
        setPromptError('')
        if(!selected_reason){
            setPromptError('Cancellation reason is required')
            return;
        }
        setPromptModal(0)
        setLoading(1)
        const url = helpers.createUrl('V1/manage/order/bills/status')

        httpRequest(url, 'POST', {
            postdata: {
                "order_id": order_id,
                "store_id": helpers.getStoreID(),
                "status_id": 4,
                "cancel_reason_id": selected_reason
            },
        }, true)
            .then((res) => {
                setLoading(0)
                fetchDataList()
                // let id = order_id;
                // if(!order_id){
                //     id = res.id
                // }

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                })
            })
            .catch((err) => {
                console.log(err)
                setLoading(0)
                
                if(err.data){
                    //setErrors( err.data );
                }else{
                    //setErrors([])
                }

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 
    }

    return (
        <Layout page_title={page_title} menu={menu}>
            
            <Modal show={prompt_modal}>
                <Modal.Header>
                    <h5>{prompt_title}</h5>
                    <Button variant="danger" size="sm" onClick={closeModal}><i className="fas fa-times"></i></Button>
                </Modal.Header>
                <Modal.Body  style={{position: 'relative'}}>
                    <div className="row">
                        <div className="col-12 form-group">
                            {prompt_caption}

                            <DropDownSelection
                                tagClass="form-control"
                                id="selected_reason"
                                name='selected_reason' 
                                placeholder='Select Cancellation Reason'
                                value={selected_reason}  
                                onChange={(e) => setSelectedReason(e.target.value)}
                                onFocus=""
                                optionList={reasons_list}
                                optionProps ={{value:'id', label:'reason'}}
                                label={<>Reason <span className='text-danger'>*</span></>}
                            />
                            <div className='text-danger' style={{fontSize: '.9rem'}}>{prompt_error}</div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" onClick={cancelOrder}>
                        Proceed
                    </Button>
                    <Button variant="secondary" onClick={closeModal}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>

            <div className="container-fluid" style={{position: 'relative'}}>
                    <Loader isLoading={loading}/>
                <div className="card">
                    <div className="card-header border-bottom-0">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="row">
                                    <div className="col-lg-4 mb-3 mb-lg-0">
                                        <DropDownSelection
                                            tagClass="form-control"
                                            id="status"
                                            name='status' 
                                            placeholder='Select Status'
                                            value={filters.status}  
                                            onChange={inputChange}
                                            onFocus=""
                                            optionList={enums.order_status}
                                            optionProps ={{value:'id', label:'bill_status'}}
                                        />
                                    </div>
                                    <div className="col-lg-6">
                                        <input type="text" name="search" className="form-control" placeholder="Search" onChange={inputChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 text-right mt-3 mt-md-0">
                                <Link className='btn btn-primary float-right' to="/bills/form"><i className="fas fa-plus-circle mr-2" />New</Link>
                                
                                {selected_items.length ?
                                <Dropdown className='float-right mr-3'>
                                    <Dropdown.Toggle className='btn-light border' id={"dropdown-actions-"}>Bulk Action</Dropdown.Toggle>
                                    <Dropdown.Menu align="end">
                                        <Dropdown.Item key="delete" className='text-danger' onClick={(e) => triggerAction(selected_items, 'bulk-delete')}><i className="fas fa-trash mr-2" />Delete</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown> : ''}
                            </div>
                        </div>
                    </div>
                    <div className="card-body p-0">
                        { data_table }
                    </div>
                </div>
            </div>
        </Layout>
    )
}